/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Finish_Thank_You_Line2Inputs */

const en_register_onboarding_finish_thank_you_line2 = /** @type {(inputs: Register_Onboarding_Finish_Thank_You_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will be automatically informed in the coming weeks when the status of your application changes (invitation to an interview or rejection).`)
};

const de_register_onboarding_finish_thank_you_line2 = /** @type {(inputs: Register_Onboarding_Finish_Thank_You_Line2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wirst in den nächsten Wochen automatisch informiert, wenn sich der Status deiner Bewerbung ändert (Einladung zum Gespräch oder Absage).`)
};

/**
* | output |
* | --- |
* | "You will be automatically informed in the coming weeks when the status of your application changes (invitation to an interview or rejection)." |
*
* @param {Register_Onboarding_Finish_Thank_You_Line2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_finish_thank_you_line2 = /** @type {((inputs?: Register_Onboarding_Finish_Thank_You_Line2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Finish_Thank_You_Line2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_finish_thank_you_line2(inputs)
	return en_register_onboarding_finish_thank_you_line2(inputs)
});